import React from "react";
import "./LoadingModal.css";

const LoadingModal = ({ message = "در حال بارگذاری..." }) => {
  return (
    <div className="loading-modal-overlay">
      <div className="loading-modal-content">
        <div className="loading-spinner"></div>
        <div className="loading-message">{message}</div>
      </div>
    </div>
  );
};

export default LoadingModal;
